export default __webpack_public_path__ + "navigation-overview-carplay-1200-d6d3cdb3054c11255f5fd14a8856ff16.png";